export const filteredCampaignGroupsConstants = {
  FILTERED_CAMPAIGN_GROUP_LOADING: 'FILTERED_CAMPAIGN_GROUP_LOADING',
  FILTERED_CAMPAIGN_GROUP_SUCCESS: 'FILTERED_CAMPAIGN_GROUP_SUCCESS',
  FILTERED_CAMPAIGN_GROUP_ERROR: 'FILTERED_CAMPAIGN_GROUP_ERROR',
};
